import { LOCAL_STORAGE_KEYS } from "../constants/local-storage-keys";
import { getFromLocalStorage } from "./manageLocalStorage";

export const isAccessible = (permission: string) => {
  const permissions = getFromLocalStorage(LOCAL_STORAGE_KEYS.PERMISSIONS);
  return !!permissions?.includes(permission);
};